import type { ComponentStyle } from "@yamada-ui/core"

export const Fade: ComponentStyle<"Fade"> = {
  baseStyle: {
    w: "100%",
  },
}
